module.exports = __webpack_public_path__ + "media/images/avatar-female-801147b956e6f3803b916ed5b9a2decc.png";